import { __rest, __assign } from 'tslib';
import React from 'react';
import { Checkmark } from '../../checkmark-mobile/Component.js';
import { OptionBase } from '../Component.js';

var styles = {"option":"select__option_99x1a","disabled":"select__disabled_99x1a","size-48":"select__size-48_99x1a","size-56":"select__size-56_99x1a","size-64":"select__size-64_99x1a","size-72":"select__size-72_99x1a","selected":"select__selected_99x1a","highlighted":"select__highlighted_99x1a","content":"select__content_99x1a","textContent":"select__textContent_99x1a"};
require('./index.css')

var OptionMobile = function (_a) {
    var _b = _a.Checkmark, Checkmark$1 = _b === void 0 ? Checkmark : _b, props = __rest(_a, ["Checkmark"]);
    return (React.createElement(OptionBase, __assign({}, props, { mobile: true, Checkmark: Checkmark$1, styles: styles })));
};

export { OptionMobile };
